import { AdminFeedbackPage } from '@/features/admin/pages/AdminFeedbackPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/admin/feedback')({
  component: AdminFeedbackPage,
});
